"use strict";
angular.module("weiboPendingRouterModule", []).
config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
  $stateProvider.state('front.editctr.weibo.pending', {
    url: '/pending?wbchannelid&channelid',
    views: {
      "main@front.editctr": {
        templateUrl: "./editingCenter/weibo/pending/pending_tpl.html",
        controller: "weiboPendingCtrl"
      }
    }
  });
}]);
